import * as helper from './../../../../../VX/View/Assets/Js/helper';
import * as Events from './Events';
import {SmilyHandler} from "./SmilyHandler";
import {replaceSmily} from "./Smilynator";

const axios = require('axios').default;

export function initChat(element: HTMLDivElement) {
	const inputField: HTMLInputElement = element.querySelector('input');
	const submitButton: HTMLImageElement = element.querySelector('#input img:first-of-type');
	const chatBox = element.querySelector('#chat');
	const ab5 = parseInt(helper.getData(element, 'ab5'));
	const ab6 = parseInt(helper.getData(element, 'ab6'));
	const windowWidth = window.innerWidth;

	new SmilyHandler(element.querySelector('#smile'), document.querySelector('#smilypreview'));

	let username = '';
	let gender = 'male'
	let messagesSent = 0;
	let autoScroll = 1;

	if (ab6 === 1 && windowWidth <= 576) {
		helper.addEventListener(chatBox, 'touchstart', () => {
			autoScroll = 0;
		})
	}

	helper.addEventListener(window, Events.MESSAGE_SENT, (data) => {
		const {name, image, message, type, id} = data.detail;
		const reply = data.detail.reply || false;
		const now = (new Date()).getTime();
		let html;

		if (type === 'host') {
			html = helper.stringToHtml(`<div class="message ${type}" id="m${now}">
						<div class="left">
							<img src="${image}" alt="" class="icon paytour" data-hostid="${id}">
						</div>
						<div class="right">
							<div class="name paytour" data-hostid="${id}">${name} <span class="timestamp">schreibt...</span></div>
						</div>
					</div>
			`);
			if (!reply) {
				helper.triggerEvent(window, Events.PAUSE_CHAT);
			}
			setTimeout(() => {
				helper.$(`#m${now}`).querySelector('.right').innerHTML =
					`<div class="name paytour" data-hostid="${id}">${name}</div>
							<div class="text">
								${message}
							</div>`;
				if (!reply) {
					helper.triggerEvent(window, Events.RESUME_CHAT);
				}
				if (autoScroll === 1) {
					setTimeout(() => {
						chatBox.scrollTop = chatBox.scrollHeight;
					}, 300);
				}
			}, message.length * 30)

		} else {
			html = helper.stringToHtml(`<div class="message ${type}" id="m${now}">
						<div class="left">
							<img src="${image}" alt="" class="icon paytour" data-hostid="${id}">
						</div>
						<div class="right">
							<div class="name paytour" data-hostid="${id}">${name}</div>
							<div class="text">
								${message}
							</div>
						</div>
					</div>
			`);
		}

		chatBox.appendChild(html);
		if (autoScroll === 1) {
			chatBox.scrollTop = chatBox.scrollHeight;
			setTimeout(() => {
				chatBox.scrollTop = chatBox.scrollHeight;
			}, 500);
		}
	})

	helper.addEventListener(window, Events.USERNAME_SELECTED, (data) => {
		username = data.detail.name;
		gender = data.detail.gender;
	})

	helper.addEventListener(inputField, 'keydown', (e) => {
		if (e.key === 'Enter') {
			sendMessage(e)
		}
	})

	function sendMessage(e: MouseEvent|KeyboardEvent) {
		e.preventDefault();
		let message = inputField.value;

		axios.post(window.location.href, {
			ns: 'Chatroom',
			key: username,
			value: message
		}, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
			.then((response) => {
				console.log(response);
			})

		if (message.trim() !== '') {
			message = replaceSmily(message);
			inputField.value = '';
			helper.triggerEvent(window, Events.MESSAGE_SENT, {
				name: username,
				id: 0,
				message,
				type: 'guest',
				image: `/VX/Chatroom/img/images/placeholder_${gender}.jpg`
			})
			messagesSent++;
			if (ab5 > 0 && messagesSent >= ab5) {
				helper.triggerEvent(window, Events.CREATE_SIGNUP, {id: 0, lock: true});
			}
		}
	}

	helper.addClickListener(submitButton, (e:MouseEvent) => {
		sendMessage(e);
	})
}
